import { tempMeeApi } from '~/services/api';
import { scopedHeaders } from '~/services/scopedHeaders';
import type { IOfficeCredentialsResponse } from '../types/OfficeMissingInfo.api';

export const getUserCredentials = async (
  officeId?: string | null,
): Promise<IOfficeCredentialsResponse> => {
  const headers = await scopedHeaders(officeId);
  const { data } = await tempMeeApi.get<IOfficeCredentialsResponse>(
    '/credential-service/user/credentials',
    { headers },
  );
  return data;
};
